<template>
  <div class="gc-list-project-wrap">
    <!-- <van-nav-bar :border="false"
            title="项目"
            right-text="审核"
            @click-right="$router.push({name:'Review'})"
        />           -->
    <!-- <van-nav-bar :border="false" v-if="isReview==1"
            title="项目"
            right-text="审核"
            @click-right="$router.push({name:'Review'})"
        />-->
    <van-nav-bar :border="false" title="项目"/>
    <form action="/">
      <van-search
        v-model="searchProject"
        shape="round"
        @search="searchPro"
        placeholder="请输入搜索关键词"
      />
    </form>
    <van-sticky class="sticky-tab">
      <div class="tab-income-outgo-wrap">
        <div
          class="item"
          @click="onTabType(1)"
          :class="{ active: activeType == 1 }"
        >
          预期收入
        </div>
        <div
          class="item"
          @click="onTabType(2)"
          :class="{ active: activeType == 2 }"
        >
          预期出资
        </div>
      </div>
      <div class="tab-project-wrap">
        <div
          class="item"
          @click="onTab(0, 1)"
          :class="{ active: activeIndex == 1 }"
        >
          待审核
        </div>
        <div
          class="item"
          @click="onTab(1, 2)"
          :class="{ active: activeIndex == 2 }"
        >
          进行中
        </div>
        <!-- <div class="item" @click="onTab(2,3)" :class="{'active':activeIndex==3}">待交付</div> -->
        <div
          class="item"
          @click="onTab(3, 4)"
          :class="{ active: activeIndex == 4 }"
        >
          待验收
        </div>
        <div
          class="item"
          @click="onTab(4, 5)"
          :class="{ active: activeIndex == 5 }"
        >
          已结束
        </div>
        <div
          class="item"
          @click="onTab(-1, 0)"
          :class="{ active: activeIndex == 0 }"
        >
          全部
        </div>
      </div>
    </van-sticky>
    <!-- <van-tabs v-model="active" sticky color="#D32F2F" title-active-color="#D32F2F">
            <van-tab title="全部">内容 1</van-tab>
            <van-tab title="待参与">内容 2</van-tab>
            <van-tab title="待审核">内容 3</van-tab>
            <van-tab title="执行中">内容 4</van-tab>
            <van-tab title="已完成">内容 4</van-tab>
        </van-tabs> -->
    <!-- :immediate-check="false" -->

    <ul class="list-project-menu">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad()"
        >
          <router-link
            tag="li"
            v-for="(item, index) in projectList"
            :to="{
              name: 'ProjectDetail',
              params: { sysno: item.ProItem.Sysno }
            }"
            class="item"
            :key="index"
          >
            <div class="title">
              {{ item.ProItem.Name }}
              <div class="edit-wrap" v-if="item.MasterUser">
                <van-icon
                  v-if="uid == item.MasterUser.Sysno && item.ProStatus == 0"
                  class="edit-bt"
                  @click.stop="handleEdit(item.ProItem.Sysno)"
                  color="#D32F2F"
                  size="0.48rem"
                  name="edit"
                />
                <i v-if="status == 0" class="i1"></i>
                <i v-else-if="status == 1" class="i3"></i>
                <i v-else-if="status == 2" class="i2"></i>
                <i v-else-if="status == 4" class="i4"></i>
                <i v-else class="i0"></i>
              </div>
            </div>
            <div class="info">
              <div v-if="status == -1">
                <p v-if="item.ProStatus == 0">
                  <span>项目状态：</span><b class="status1">待审核</b>
                </p>
                <p v-if="item.ProStatus == 1">
                  <span>项目状态：</span><b class="status1">进行中</b>
                </p>
                <p v-if="item.ProStatus == 2">
                  <span>项目状态：</span><b class="status1">待交付</b>
                </p>
                <p v-if="item.ProStatus == 3">
                  <span>项目状态：</span><b class="status1">待验收</b>
                </p>
                <p v-if="item.ProStatus == 4">
                  <span>项目状态：</span><b class="status1">已结束</b>
                </p>
              </div>
              <p><span>项目金额：</span>¥{{ item.ProMoney }}</p>
              <p>
                <span>项目时间：</span
                >{{
                  item.ProDate.substr(0, 10) +
                  "至" +
                  item.ProDate.substr(11, 10)
                }}
              </p>
              <p><span>参与人数：</span>{{ item.JoinPeo }}人</p>
              <p>
                <span>项目进度：</span
                >{{ item.ProRunStatus == "-1.00%" ? "0%" : item.ProRunStatus }}
              </p>
              <p v-if="!item.MasterUser" style="color:red">
                <span>备注：</span>项目异常，请联系管理员删除后重新创建
              </p>
            </div>
          </router-link>
        </van-list>
      </van-pull-refresh>
    </ul>
  </div>
</template>

<script>
var isKeepAlive = false; //是否保持缓存状态
var isClick = false; //是否是tab点击
export default {
  data() {
    return {
      activeIndex: 1,
      status: 0,
      projectList: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 1,
      pcount: 10,
      allcount: 0,
      isReview: localStorage.getItem("ReponseLog"),
      searchProject: "",
      activeType: 1, //1我参与的项目（验收、创建、执行）；2我出资的项目
      uid: localStorage.getItem("UserSysno"),
      flag: false
    };
  },
  mounted() {
    // this.WebGetProjectSimpleInfoLst(this.status);
  },
  watch: {
    $route(to, from) {
      console.log(from);
      if (from.name == "ProjectDetail") {
        this.onRefresh();
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    console.log(from);
    if (from.name == "ProjectDetail") {
      // to.meta.keepAlive = true;
      isKeepAlive = true;
      isClick = false;
    } else {
      // to.meta.keepAlive = false;
      isKeepAlive = false;
    }
    next();
  },
  // 离开
  deactivated() {
    console.log("deactivated");
  },
  // 进入
  activated() {
    console.log("activated");
    // this.onRefresh();
  },
  methods: {
    onLoad() {
      console.log("onLoad");
      this.WebGetProjectSimpleInfoLst(this.status);
    },
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.page = 1;
      this.projectList = [];
      this.onLoad();
    },
    // 项目搜索
    searchPro() {
      this.flag = true;
      this.onRefresh();
    },
    WebGetProjectSimpleInfoLst(status) {
      let data = {
        RequestId: this.activeType, // 收入或支出
        UserSysno: localStorage.getItem("UserSysno"),
        SearchKey: this.searchProject,
        StatusKey: status, //0待审核 1进行中 2待交付 3待验收 4已结束 -1全部
        // DepSysno: localStorage.getItem('GovDepSysno'),
        page: this.page,
        pcount: this.pcount
      };
      if (localStorage.getItem("isBoss") == 1) {
        data = {
          RequestId: this.activeType,
          // UserSysno:'US2018040813033200040',
          StatusKey: status,
          page: this.page,
          pcount: this.pcount
        };
      }
      this.$baseajax.normalJsonp(
        this.$base.baseProject + "/WebNewGetProjectSimpleInfoLst",
        data,
        res => {
          console.log("列表", res);

          if (this.refreshing) {
            this.refreshing = false;
          }
          this.loading = false;

          res = res.WebNewGetProjectSimpleInfoLstResult;
          if (res.ResponseCode == 1) {
            this.allcount = res.AllCount;
            if (res.ItemLst && !this.flag) {
              this.projectList.push(...res.ItemLst);
            } else if (res.ItemLst && this.flag) {
              this.projectList = res.ItemLst;
              this.flag = false;
            } else if (!res.ItemLst && this.flag) {
              this.projectList = [];
              this.flag = false;
            } else {
            }

            if (this.projectList.length >= this.allcount) {
              this.finished = true;
            } else {
              this.page++;
            }

            // 位置保存 如果是详情返回的记录保存位置
            setTimeout(() => {
              // console.log(window.targetPosition);
              if (window.targetPosition && isKeepAlive && !isClick) {
                window.scrollTo(
                  window.targetPosition.x,
                  window.targetPosition.y
                );
              }
            }, 0);
          } else {
            this.finished = true;
          }
        },
        err => {
        }
      );
    },
    onTab(status, index) {
      this.activeIndex = index;
      this.status = status;
      isClick = true;
      this.onRefresh();
    },
    onTabType(i) {
      this.activeType = i;
      isClick = true;
      this.onRefresh();
    },
    handleEdit(sysno) {
      this.$router.push({
        name: "AddProject",
        query: {
          sysno: sysno
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/base.less";

/deep/ .van-tab {
  font-size: 0.4rem;
}

.tab-income-outgo-wrap {
  display: flex;
  background: #f6f6f6;
  height: 1.2rem;
  line-height: 1.2rem;
  padding: 0 0.28rem;

  .item {
    width: 3rem;
    font-size: 0.42rem;
    color: #333;

    &.active {
      color: @color;
    }
  }
}

.tab-project-wrap {
  box-shadow: none;
}

.sticky-tab {
  box-shadow: 0rem 0.01rem 0.13rem 0rem rgb(42 48 158 / 11%);
}

.gc-list-project-wrap {
  padding-bottom: 1.6rem;
}

.list-project-menu {
  margin: 0.28rem 0.28rem 0;
  padding: 0 0.48rem;
  background-color: #ffffff;
  box-shadow: 0rem 0rem 0.28rem 0rem rgba(211, 47, 47, 0.14);
  border-radius: 0.27rem;

  .item {
    padding: 0.5rem 0;
    border-top: 1px solid #ddd;

    &:first-child {
      border-top: none;
    }

    .title {
      font-size: 0.4rem;
      font-weight: 700;
      color: #333333;
      display: flex;
      justify-content: space-between;
      margin-bottom: 0.3rem;

      .edit-wrap {
        display: flex;

        .edit-bt {
          margin-left: 0.2rem;
          flex: 0 0 0.48rem;
        }
      }

      i {
        flex: 0 0 0.48rem;
        margin-left: 0.2rem;
        width: 0.48rem;
        height: 0.48rem;
        background-size: contain;

        &.i0 {
          background-image: url("~@/assets/more.png");
        }

        &.i1 {
          background-image: url("~@/assets/join.png");
        }

        &.i2 {
          background-image: url("~@/assets/more.png");
        }

        &.i3 {
          background-image: url("~@/assets/ing.png");
        }

        &.i4 {
          background-image: url("~@/assets/finished.png");
        }
      }
    }

    .info {
      font-size: 0.3rem;
      color: #888888;

      p {
        margin-top: 0.08rem;
      }

      span {
        font-size: 0.32rem;
        color: #666666;
      }

      b {
        font-weight: normal;

        &.status1 {
          color: #0090ff; //待参与
        }

        &.status2 {
          color: #B71C1C; //待审核
        }

        &.status3 {
          color: #D32F2F; //执行中
        }

        &.status4 {
          color: #9ee355; //已完成
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/project/Project.vue